import { render } from "./adminView.vue?vue&type=template&id=729b35e2&scoped=true"
import script from "./adminView.vue?vue&type=script&lang=js"
export * from "./adminView.vue?vue&type=script&lang=js"

import "./adminView.vue?vue&type=style&index=0&id=729b35e2&lang=scss"
import "./adminView.vue?vue&type=style&index=1&id=729b35e2&lang=scss&scoped=true"

import exportComponent from "/Users/ethan/Desktop/zixel/zetaverseDev/zetaverseweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-729b35e2"]])

export default __exports__